import { getCompletionPercent, getMissingSections } from "./packageWizardConfig";

const PackageCompletionTracker = ({
  completedStage,
  compact = false,
  wide = false,
}) => {
  const percent = getCompletionPercent(completedStage);
  const missing = getMissingSections(completedStage);

  if (compact) {
    return (
      <div className="flex min-w-0 items-center gap-3">
        <div className="hidden min-w-[120px] flex-col gap-1 sm:flex">
          <div className="flex items-center justify-between gap-2">
            <span className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
              Completion
            </span>
            <span className="text-sm font-bold text-gray-900">{percent}%</span>
          </div>
          <div
            className={`h-2 overflow-hidden rounded-full bg-gray-100 ${
              wide ? "w-32 lg:w-40" : "w-24"
            }`}
          >
            <div
              className="h-full rounded-full bg-primary transition-all duration-500"
              style={{ width: `${percent}%` }}
            />
          </div>
        </div>
        <div className="flex items-center gap-2 sm:hidden">
          <div className="h-2 w-20 overflow-hidden rounded-full bg-gray-100">
            <div
              className="h-full rounded-full bg-primary transition-all duration-500"
              style={{ width: `${percent}%` }}
            />
          </div>
          <span className="text-sm font-semibold text-gray-900">{percent}%</span>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-gray-200/80 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Package Completion
        </p>
        <span className="text-sm font-bold text-gray-900">{percent}%</span>
      </div>

      <div className="mt-3 h-2 overflow-hidden rounded-full bg-gray-100">
        <div
          className="h-full rounded-full bg-primary transition-all duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>

      {missing.length > 0 && (
        <div className="mt-4">
          <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
            Still needed
          </p>
          <ul className="mt-2 space-y-1">
            {missing.slice(0, 4).map((name) => (
              <li
                key={name}
                className="flex items-center gap-2 text-xs text-gray-600"
              >
                <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400" />
                {name}
              </li>
            ))}
            {missing.length > 4 && (
              <li className="text-xs text-gray-400">
                +{missing.length - 4} more sections
              </li>
            )}
          </ul>
        </div>
      )}

      {missing.length === 0 && (
        <p className="mt-3 text-xs text-emerald-700">
          <i className="fi fi-rr-check relative top-0.5 mr-1 text-emerald-500"></i>
          All sections complete
        </p>
      )}
    </div>
  );
};

export default PackageCompletionTracker;
